// extracted by mini-css-extract-plugin
export default {"container":"App_container__ZptGK","contents":"App_contents__X+x3s","nav":"App_nav__corgB","line":"App_line__LPY4J","center":"App_center__s8Cxw"};